import PropTypes from 'prop-types';
import {FmlxDropdown, FmlxTextBox, FmlxIcon, FmlxLabel, FmlxCheckBox} from 'fmlx-common-ui';
import React, {Component} from 'react';
import {parseInt} from 'lodash';

const INPUT_TYPE = {
  INPUT: 'input',
  DROPDOWN: 'dropdown',
  CHECKBOX: 'checkbox',
};

export default class SingleInputFormUser extends Component {
  getInputForm = () => {
    const {
      type,
      inputType,
      placeholder,
      value,
      onChange,
      options,
      valueKey,
      labelKey,
      onSelect,
      label,
      checked,
      checkedChanged,
      onInputKeyPressed,
      disabled,
      alertMessageContent,
      onBlur,
      enableAlert,
      id,
    } = this.props;
    let inputForm = {};
    const styleInput = alertMessageContent === '' || !alertMessageContent ? {} : {borderColor: '#C92932'};

    switch (type) {
      case INPUT_TYPE.INPUT: {
        inputForm = (
          <>
            <FmlxLabel label={this.getLabelHeader()} />
            <FmlxTextBox
              mode={inputType}
              placeholder={placeholder}
              value={value || ''}
              onChange={onChange}
              onBlur={onBlur}
              disabled={disabled}
              decoration="icon"
              icon={this.getGlyphicon()}
              error={enableAlert && alertMessageContent !== ''}
              inlineText={alertMessageContent}
              style={{width: '100%', ...styleInput}}
              autoValue={false}
              autoComplete={false}
              onEnterKeyPressed={onInputKeyPressed}
              id={id}
            />
          </>
        );
        break;
      }
      case INPUT_TYPE.DROPDOWN: {
        inputForm = (
          <div onClick={(e) => e.stopPropagation()} aria-hidden="true">
            <FmlxLabel label={this.getLabelHeader()} />
            <FmlxDropdown
              id={id}
              valueKey={valueKey}
              labelKey={labelKey}
              items={options}
              onChange={onSelect}
              placeholder={placeholder}
              selectedItem={parseInt(value)}
              disabled={disabled}
              style={styleInput}
              labelPlacement="top"
            />
          </div>
        );
        break;
      }
      case INPUT_TYPE.CHECKBOX: {
        inputForm = (
          <>
            <FmlxLabel label={this.getLabelHeader()} />
            <FmlxCheckBox
              checked={checked}
              label={label}
              onChange={checkedChanged}
              hint={alertMessageContent}
              disabled={disabled}
            />
          </>
        );
        break;
      }
      default:
        break;
    }

    return inputForm;
  };

  getLabelHeader = () => {
    const {labelHeader, required} = this.props;
    let header = '';

    if (labelHeader !== '') {
      header = (
        <label className="control-label" htmlFor={labelHeader}>
          {labelHeader}
          {required && <span style={{color: 'red'}}>*</span>}
        </label>
      );
    }

    return header;
  };

  getGlyphicon = () => {
    const {glyph} = this.props;
    // eslint-disable-next-line react/jsx-no-useless-fragment
    let glyphicon = <></>;

    if (glyph !== '') {
      glyphicon = <FmlxIcon name={glyph} />;
    }

    return glyphicon;
  };

  // eslint-disable-next-line react/no-unused-class-component-methods
  getAlertMessage = () => {
    const {alertMessageContent, enableAlert} = this.props;
    let content = '';

    if (alertMessageContent !== '') {
      content = <div className="alert-container">{alertMessageContent}</div>;
    }

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{enableAlert && content}</>;
  };

  render() {
    return <div className="form-group has-feedback">{this.getInputForm()}</div>;
  }
}

SingleInputFormUser.propTypes = {
  id: PropTypes.string,
  enableAlert: PropTypes.bool,
  options: PropTypes.array,
  required: PropTypes.bool,
  labelHeader: PropTypes.string,
  alertMessageContent: PropTypes.any,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  inputType: PropTypes.string,
  valueKey: PropTypes.string,
  labelKey: PropTypes.string,
  label: PropTypes.string,
  checked: PropTypes.bool,
  glyph: PropTypes.string,
  checkedChanged: PropTypes.func,
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
  onBlur: PropTypes.func,
  onInputKeyPressed: PropTypes.func,
};

SingleInputFormUser.defaultProps = {
  id: '',
  enableAlert: true,
  options: [],
  required: false,
  labelHeader: '',
  alertMessageContent: '',
  placeholder: '',
  value: '',
  disabled: false,
  type: '',
  inputType: '',
  valueKey: '',
  labelKey: '',
  label: '',
  checked: false,
  glyph: '',
  checkedChanged: () => {},
  onChange: () => {},
  onSelect: () => {},
  onBlur: () => {},
  onInputKeyPressed: () => {},
};
